module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/041-paraguay-f5ad36ac70976cdc14144e36a4662dfb.svg";